export const blue = "#0071bb";
export const primary = "#0071bb";
export const darkSkyBlue = "#48a0da";
export const lightBlue = "#dbecf7";
export const sealBlue = "#a5adba";
export const lightestBlue = "#ebf4fa";
export const lightSealBlue = "#e4e7ec";
export const lightestSealBlue = "#f2f4f8";
export const mediumBlue = "#dbebf6";
export const success = "#5ad269";
export const greenSuccess = "#28d094";
export const infoBlue = "#4bcae1";
export const lightGreen = "#4be1ab";
export const lightestGreen = "#a5f0d5";
export const red = "#ff7171";
export const orange = "#f1aa4e";
export const mediumGray = "#797979";
export const lightGray = "#d8d8d8";
export const lightestGray = "#f2f2f2";
export const darkGray = "#666666";
export const washGray = "#fafafa";
export const lightRed = "#ffdfdf";
export const text = "#212121";
export const darkSkyLightBlue = "#48a0d9";
export const disruptiveBlue = "#005aee";
